<template>
  <BaseVeeForm :action="submitForm">
    <template #default="formProps">
      <div
        v-for="(item, idx) in formData.documentTypes"
        :key="idx"
        class="bg-white flex items-start"
      >
        <div class="flex-1 px-6 py-4">
          <ValidationProvider rules="required" name="name" slim :vid="`document_types.${idx}.name`">
            <template #default="{ errors }">
              <BaseFormGroup>
                <BaseFormInput type="text" v-model="item.name" :disabled="formProps.isPending" />
                <BaseFormInlineMessage v-if="errors.length" danger>
                  {{ errors[0] }}
                </BaseFormInlineMessage>
              </BaseFormGroup>
            </template>
          </ValidationProvider>
        </div>
        <div class="w-64 px-6 py-4">
          <ValidationProvider
            rules="required"
            name="document type"
            slim
            :vid="`document_types.${idx}.document_type`"
          >
            <template #default="{ errors }">
              <BaseFormGroup>
                <BaseFormSelect
                  v-model="item.documentType"
                  :options="documentTypeOptions"
                  :disabled="formProps.isPending"
                  required
                  class="w-full"
                />
                <BaseFormInlineMessage v-if="errors.length" danger>
                  {{ errors[0] }}
                </BaseFormInlineMessage>
              </BaseFormGroup>
            </template>
          </ValidationProvider>
        </div>
        <div class="w-40 px-6 py-4">
          <ValidationProvider
            rules="required"
            name="number"
            slim
            :vid="`document_types.${idx}.number`"
          >
            <template #default="{ errors }">
              <div>
                <BaseFormInput type="text" v-model="item.number" :disabled="formProps.isPending" />
                <BaseFormInlineMessage v-if="errors.length" danger>
                  {{ errors[0] }}
                </BaseFormInlineMessage>
              </div>
            </template>
          </ValidationProvider>
        </div>
        <div class="w-40 px-6 py-4">
          <ValidationProvider name="follows" slim :vid="`document_types.${idx}.follows`">
            <template #default="{ errors }">
              <BaseFormGroup>
                <BaseFormInput type="text" v-model="item.follows" :disabled="formProps.isPending" />
                <BaseFormInlineMessage v-if="errors.length" danger>
                  {{ errors[0] }}
                </BaseFormInlineMessage>
              </BaseFormGroup>
            </template>
          </ValidationProvider>
        </div>
        <div class="w-40 px-6 py-4 flex space-x-2">
          <button
            type="button"
            class="w-full inline-flex items-center px-4 py-2 border text-sm justify-center font-medium rounded-md bg-white focus:outline-none disabled:border-transparent disabled:text-gray-500 border-gray-300 text-red-600 hover:bg-gray-50 focus:border-blue-600"
            :disabled="formProps.isPending || formProps.invalid"
            @click="removeDocumentType(idx)"
          >
            Remove
          </button>
        </div>
      </div>
      <div class="px-6 py-4">
        <button
          type="submit"
          class="w-full inline-flex items-center px-4 py-2 border text-sm justify-center font-medium rounded-md bg-white focus:outline-none disabled:border-transparent disabled:text-gray-500 border-gray-300 text-gray-700 hover:bg-gray-50 focus:border-blue-600"
          :disabled="formProps.isPending || formProps.invalid"
        >
          Update
        </button>
      </div>
    </template>
  </BaseVeeForm>
</template>

<script>
import { omit } from 'lodash-es';
import { softOneApiServiceConfigDocumentTypesClient } from '@/api/clients';

export default {
  props: {
    softOneServiceId: {
      type: String,
      required: true,
    },
    initialData: {
      type: Array,
      required: true,
    },
  },
  data() {
    return {
      formData: {
        documentTypes: [...this.initialData],
      },
      documentTypeOptions: [
        { value: 'orders', label: 'Orders' },
        { value: 'credit notes', label: 'Credit notes' },
      ],
    };
  },
  watch: {
    initialData: 'updateInitialData',
  },
  methods: {
    updateInitialData(initialData) {
      this.formData.documentTypes = [...initialData];
    },
    removeDocumentType(index) {
      this.formData.documentTypes = [...Object.values(omit(this.formData.documentTypes, [index]))];
    },
    async submitForm() {
      try {
        this.$emit('updating');
        await this.$store.dispatch('ui/thirdPartyServices/updateFromService', {
          id: this.softOneServiceId,
          formData: { ...this.formData },
          service: softOneApiServiceConfigDocumentTypesClient.update,
        });

        return Promise.resolve();
      } catch (error) {
        return Promise.reject(error);
      } finally {
        this.$emit('updated');
      }
    },
  },
};
</script>
